// extracted by mini-css-extract-plugin
module.exports = {"affiliateNav":"affiliate-nav_affiliateNav_2PaFv","elMenu":"affiliate-nav_elMenu_108Xf"};